import React, { SVGAttributes } from 'react'
import styled, { keyframes } from 'styled-components'

import { StyledSpan, TStyledSpanProps } from 'elements/media/Icon'

const dash = keyframes`
  0% {
    color: currentColor;
    stroke-dashoffset: 1000;
  }
  100% {
    color: currentColor;
    stroke-dashoffset: 0;
  }
`
const dashCheck = keyframes`
  0% {
    color: currentColor;
    stroke-dashoffset: -100;
  }
  100% {
    color: currentColor;
    stroke-dashoffset: 900;
  }
`

type TStyledSvgElementProps = SVGAttributes<SVGCircleElement | SVGPolylineElement> & { delay: number }

const StyledCircle = styled.circle<TStyledSvgElementProps>`
  animation: ${dash} 0.9s ${({ delay }) => delay}ms ease-in-out forwards;
`

const StyledPolyline = styled.polyline<TStyledSvgElementProps>`
  animation: ${dashCheck} 0.9s ${({ delay }) => delay}ms ease-in-out forwards;
`

export type TAnimatedCheckIconProps = TStyledSpanProps & Pick<Partial<TStyledSvgElementProps>, 'delay'>

export const AnimatedCheckIcon: TFCC<TAnimatedCheckIconProps> = ({
  color = 'green',
  delay = 500,
  size = '4em',
  ...otherProps
}) => {
  const commonProps: TStyledSvgElementProps = {
    delay,
    fill: 'none',
    color: 'transparent',
    stroke: 'currentColor',
    strokeWidth: '12',
  }

  return (
    <StyledSpan size={size} color={color} {...otherProps}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <StyledCircle
          {...commonProps}
          strokeMiterlimit="10"
          strokeDasharray="1000"
          strokeDashoffset="0"
          cx="65"
          cy="65"
          r="55.1"
        />
        <StyledPolyline
          {...commonProps}
          strokeLinecap="round"
          strokeMiterlimit="5"
          strokeDasharray="1000"
          strokeDashoffset="-100"
          points="90.2,50.2 60,85 45,70"
        />
      </svg>
    </StyledSpan>
  )
}
